import React from 'react'
import { connect } from 'react-redux'


const styles = {
  root: {
    padding: '10px',
  },
  bar: (progress => ({
    height: '20px',
    backgroundColor: '#2f960d',
    width: (`${progress}%`),
    borderRadius: '5px',
  })),
  progress: {
    width: '90%',
    backgroundColor: '#c2c2c2',
    position: 'relative',
    margin: 'auto',
    borderRadius: '5px',
  },
  percent: {
    position: 'absolute',
    left: '0',
    right: '0',
    color: '#ffffff',
    textAlign: 'center',
  },
}


class PreMissionShow extends React.Component {


  render() {
    const { total_done_repeats, total_max_repeats } = this.props
    return (
      (total_max_repeats === 1 ? null :
      <div style={styles.root}>
        <h4>Veces terminada</h4>
        <div id="progress" style={styles.progress}>
          <div style={styles.percent}>{total_done_repeats}/{total_max_repeats}</div>
          <div style={styles.bar(total_done_repeats * 100 / total_max_repeats)} />
        </div>
      </div>
      )
    )
  }
}


const mapStateToProps = state => ({
  ...state.missions.selectedMission,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(PreMissionShow)



// WEBPACK FOOTER //
// ./src/components/CampaignShow/PreMissionShow/MissionAdvance/index.jsx